package or.garden.manager.components

import gardenmanager.composeapp.generated.resources.Res
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import org.jetbrains.compose.resources.ExperimentalResourceApi

object LocaleManager {
    private var stringMap: Map<String, String> = emptyMap()
    var lang = "bs"

    @OptIn(ExperimentalResourceApi::class)
    fun loadStrings(languageCode: String, callback: () -> Unit) {
        lang = languageCode

        CoroutineScope(Dispatchers.Main).launch {
            try {
                val bytes = Res.readBytes("files/strings_$languageCode.json")
                val jsonString = bytes.decodeToString()

                val jsonElement = Json.parseToJsonElement(jsonString).jsonObject
                stringMap = jsonElement.mapValues { it.value.jsonPrimitive.content }
            } catch (e: Exception) {
                println("Greška pri učitavanju: ${e.message}")
            } finally {
                callback()
            }
        }
    }

    fun getString(key: String): String {
        return stringMap[key] ?: "[$key]"
    }
}